import script from "./MsToastMsgNotify.vue?vue&type=script&setup=true&lang=js"
export * from "./MsToastMsgNotify.vue?vue&type=script&setup=true&lang=js"

import "./MsToastMsgNotify.vue?vue&type=style&index=0&id=505a4e05&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-505a4e05"]])

export default __exports__